import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const MapComponent = ({ location }) => {
  const mapStyles = {
    height: "200px",
    width: "100%",
  };

  // Provide fallback coordinates if location is undefined or missing lat/lng
  const defaultCenter = {
    lat: location?.lat || 48.1351, // Default to Munich coordinates
    lng: location?.lng || 11.582,
  };

  // Show a placeholder if no valid location is provided
  if (!location || (!location.lat && !location.lng)) {
    return (
      <div
        style={mapStyles}
        className="flex items-center justify-center bg-gray-100 border border-gray-300 rounded"
      >
        <p className="text-gray-500 text-sm">Location not available</p>
      </div>
    );
  }

  return (
    <LoadScript googleMapsApiKey="AIzaSyCH1gcLJjn9iOvrfOXlcOhe_B4Qj9ayxec">
      <GoogleMap mapContainerStyle={mapStyles} zoom={15} center={defaultCenter}>
        <Marker position={defaultCenter} />
      </GoogleMap>
    </LoadScript>
  );
};

export default MapComponent;
